import React from "react";
import { Link } from "react-router-dom";

const Kicked: React.FC = () => {
  return (
    <div className="bg-[#BCB7A8] font-['IBM_Plex_Mono',monospace] text-black m-0 p-0 flex flex-col justify-center items-center h-[100vh]">
      <div className="container w-auto p-3 md:max-w-[900px] text-center">
        <div className="header text-[2rem] font-bold leading-[1.6] mb-8">
          You have been kicked from the game
        </div>

        <p className="mb-8 text-xl leading-relaxed">
          Your session has ended. You can return to the main play screen to
          start or join another game.
        </p>

        <Link
          to="/play"
          className="menu-button border-2 border-black px-6 py-4 bg-[#BCB7A8] text-xl"
        >
          Back to Play
        </Link>
      </div>
    </div>
  );
};

export default Kicked;
